import { useEffect, useRef } from "react";
import styles from "./PhotoWall.module.scss";

const PhotoWall = () => {
  const imageContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!imageContainerRef.current) return;

      const scrollPosition = window.scrollY - 1200;
      const moveSpeed = 0.25;
      imageContainerRef.current.style.left = `-${scrollPosition * moveSpeed}px`;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section
      id="photo-wall"
      className={styles["photo-wall"]}
      ref={imageContainerRef}
    >
      <div className={styles.wrapper}>
        <div className={styles.column}>
          <div
            className={styles.img}
            style={{
              backgroundImage: "url(photo_wall05.png)",
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div
            className={styles.img}
            style={{
              backgroundImage: "url(photo_wall06.png)",
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
        </div>
        <div className={styles.column}>
          <div
            className={styles.img}
            style={{
              backgroundImage: "url(photo_wall01.png)",
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
        </div>
        <div className={styles.column}>
          <div
            className={styles.img}
            style={{
              backgroundImage: "url(photo_wall02.png)",
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div
            className={styles.img}
            style={{
              backgroundImage: "url(photo_wall03.png)",
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default PhotoWall;
